/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function PuzzlePiece(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M165.78027,224.001,207.99951,224a16.018,16.018,0,0,0,16-16L224,170.34863a7.99966,7.99966,0,0,0-11.05957-7.3916A23.25464,23.25464,0,0,1,204,164.72754c-13.2334,0-24-11.09277-24-24.72754s10.7666-24.72754,24-24.72754a23.25464,23.25464,0,0,1,8.94043,1.77051A7.99966,7.99966,0,0,0,224,109.65137L223.99951,72A16.01812,16.01812,0,0,0,207.999,56l-36.21728.001A36.60975,36.60975,0,0,0,171.99951,52a36,36,0,0,0-72,0,36.60975,36.60975,0,0,0,.21778,4.001L63.99951,56a16.018,16.018,0,0,0-16,16L48,104.21777A36.47481,36.47481,0,0,0,43.99951,104a36,36,0,0,0,0,72A36.47481,36.47481,0,0,0,48,175.78223L47.99951,208A16.01791,16.01791,0,0,0,63.999,224l42.22071.001h0" />
    </Svg>
  );
}

export default PuzzlePiece;
